module.exports = __webpack_public_path__ + "img/cyt.6ef16aba.png";